'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
require('../node_modules/prop-types/index.js');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

function areEqual(prevProps, nextProps) {
  return prevProps.initialX === nextProps.initialX;
}

var DragBoundry = /*#__PURE__*/React__namespace.memo(_ref => {
  var {
    left = 0,
    width = 0,
    initialX,
    onMouseUp
  } = _ref;
  var [currentX, setCurrentX] = React__namespace.useState(initialX);

  function onMouseMove(event) {
    setCurrentX(event.clientX);
  }

  function handleMouseUp() {
    onMouseUp(currentX);
  }

  React__namespace.useEffect(() => {
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
    return () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [handleMouseUp]);
  var resizeWidth = Math.min(500, Math.max(36, width + (currentX - initialX)));
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: "GenjoDataTable__drag-boundry",
    style: {
      left,
      width: resizeWidth
    }
  });
}, areEqual);
DragBoundry.displayName = 'DragBoundry';
DragBoundry.propTypes = {};

exports.DragBoundry = DragBoundry;
